import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function consolidated() {
    return {
        index,
        get,
        save,
        remove,
        receiptsAvailable,
        whrecAvailable,
        guidesAvailable,
        loadUnitAvailable,
        addItem,
        addReceipts,
        removeItem,
        addImage,
        removeImage,
        closeConsol,
        reOpenConsol,
        deliveryConsol,
        revertDeliveryConsol,
        printLabel,
        exportConsolFile,
        addItemByScan,
        printCustomLabel
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`consolidated/get?id=${id}`);
    }

    function save(payload) {
        if (payload.id) {
            return axiosInstance.patch('consolidated/update', payload);
        } else {
            return axiosInstance.post('consolidated/create', payload);
        }
    }

    function remove(id) {
        console.log('ID:', id);
        return axiosInstance.delete(`consolidated/delete`, {
            data: id
        });
    }

    function receiptsAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated/available-receipts${params}`);
    }

    function whrecAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated/available-warehouses${params}`);
    }

    function guidesAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated/available-guides${params}`);
    }

    function loadUnitAvailable(options) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`consolidated/available-loadunit${params}`);
    }

    function addItem(payload) {
        return axiosInstance.post('consolidated/add-items', payload);
    }

    function addReceipts(payload) {
        return axiosInstance.post('consolidated/add-receipts', payload);
    }

    function removeItem(payload) {
        return axiosInstance.delete('consolidated/remove-items', {
            data: JSON.stringify(payload)
        });
    }

    function addItemByScan(payload) {
        return axiosInstance.post('consolidated/add-item-barcode', payload);
    }

    function addImage(image, id) {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('id', id);

        return axiosInstance.post('consolidated/add-image', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    function removeImage(id, imageId) {
        return axiosInstance.delete(`consolidated/delete-image`, {
            data: {
                consolId: id,
                imageId: imageId
            }
        });
    }

    function closeConsol(id) {
        return axiosInstance.post('consolidated/close', { id });
    }

    function reOpenConsol(id, comment) {
        return axiosInstance.post('consolidated/reopen', { id, comment });
    }

    function deliveryConsol(id, comment) {
        return axiosInstance.post('consolidated/delivered', { id, comment });
    }

    function revertDeliveryConsol(id) {
        return axiosInstance.post('consolidated/revert-delivered', { id });
    }

    function exportConsolFile(options = {}, type = 'pdf') {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            format: type
        };
        let params = {};
        let headers = {};

        if (type === 'pdf') {
            const args = options ? JSON.parse(options) : null;
            params = generateQueryParams(args.query, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            };
        } else {
            params = generateQueryParams(options, defaultValues);
            headers = {
                timeout: 60000,
                responseType: 'arraybuffer'
            };
        }
        return axiosInstance.get(`consolidated/export${params}`, headers);
    }

    function printLabel(id) {
        return axiosInstance.get(`consolidated/label?id=${id}`, {
            timeout: 60000,
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function printCustomLabel(id, formatId) {
        return axiosInstance.get(
            `consolidated/label-custom?id=${id}&labelFormatId=${formatId}`,
            {
                timeout: 60000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/json'
                }
            }
        );
    }
}
